// Shared visual + labelling primitives for the Order Intake panel (OI-3).
// Lives next to the panel + drawer so both files stay under the 400-line
// hygiene cap without duplicating button class strings or label maps.

import type {
  OpsOrderIntakeKind,
  OpsOrderIntakeSource,
} from "@/lib/orderIntakeClient";

export {
  mfgPrimaryBtnClass as primaryBtnClass,
  ghostBtnClass,
  adminDangerGhostBtnClass as dangerBtnClass,
  inputClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";

export const SOURCE_LABELS: Record<OpsOrderIntakeSource, string> = {
  inventory_host_customer_order: "inventory host · Customer",
  inventory_host_inventory_order: "inventory host · Inventory",
  in_app_customer: "In-app · Customer",
  in_app_inventory: "In-app · Inventory",
  in_app_dealer: "Dealer · Customer",
  manual_import: "Manual import",
  idearoom_export: "IdeaRoom",
  sensei_export: "Sensei",
};

export const KIND_LABELS: Record<OpsOrderIntakeKind, string> = {
  customer: "Customer order",
  inventory: "Inventory build",
};

export function formatIntakeDateTime(iso: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString();
}
